<div class="header-container">
    <div class="search-box">
        <input type="text" placeholder="Search" 
        [(ngModel)]="searchText" 
        (keyup)="typed($event)" />
        <i class="fa fa-search"></i>
    </div>

    <thera-button *ngIf="canAccess" matTooltip="Only associated discipline allowed." class="mr-2" [config]="{
      variant: buttonVariant.PRIMARY,
      text: 'Sign'
    }"
    [disabled]="!enableSign"
    (click)="onClickSign()"></thera-button>
</div>
<div class="billing-container overflow-y-auto">
    <thera-client-side-list [columnDefs]="columnDefs" [rowData]="rowData" noRowsTemplate="No records found."
        (selectionChanged)="selectedForCoSign($event)" [rowSelection]="'multiple'" [detailRowsEnabled]="true"
        [isRowMaster]="isRowMaster" [detailCellRenderer]="detailCellRenderer"
        [detailRowRenderParams]="detailCellRendererParams" [suppressRowClickSelection]="true">
    </thera-client-side-list>
</div>